@let s = series();
@if (s.available()) {
  <section
    data-testid="report-series-section"
    class="proffeo-ui-surface-card flex flex-col gap-3 p-3"
  >
    <mat-slide-toggle
      (change)="s.setEnabled($event.checked)"
      [checked]="s.active()"
      data-testid="report-series-toggle"
    >
      {{ 'time-reports.series.create' | translate }}
    </mat-slide-toggle>

    @if (s.active()) {
      <p
        role="note"
        class="proffeo-ui-text-muted m-0 text-sm"
      >
        {{ 'time-reports.series.test-api-notice' | translate }}
      </p>

      <proffeo-ui-date-range-picker
        [formField]="s.form.dateRange"
        [errorMessage]="s.dateRangeErrorKey()"
        label="time-reports.series.date-range"
      />

      <div class="flex flex-col gap-1">
        <span class="proffeo-ui-text-muted text-sm">{{ 'time-reports.series.included-weekdays' | translate }}</span>
        <div
          [attr.aria-label]="'time-reports.series.included-weekdays' | translate"
          role="group"
          class="report-series-weekdays"
        >
          @for (weekday of weekdayOptions; track weekday.value) {
            <button
              (click)="s.toggleWeekday(weekday.value)"
              [attr.aria-label]="weekday.label | translate"
              [attr.aria-pressed]="s.isWeekdaySelected(weekday.value)"
              [class.report-series-weekday--selected]="s.isWeekdaySelected(weekday.value)"
              [class.report-series-weekday--saturday]="isWeekend(weekday.value) === 'saturday'"
              [class.report-series-weekday--sunday]="isWeekend(weekday.value) === 'sunday'"
              type="button"
              class="report-series-weekday"
            >
              {{ weekday.shortLabel | translate }}
            </button>
          }
        </div>
        @if (s.weekdaysErrorKey()) {
          <mat-error class="text-sm">{{ s.weekdaysErrorKey() | translate }}</mat-error>
        }
      </div>

      @if (s.rangeMode()) {
        <div class="flex flex-col gap-2">
          <mat-checkbox
            (change)="s.setBreakEnabled($event.checked)"
            [checked]="s.model().breakEnabled"
            data-testid="report-series-break-toggle"
          >
            {{ 'time-reports.series.deduct-break' | translate }}
          </mat-checkbox>

          @if (s.model().breakEnabled) {
            <div class="grid grid-cols-1 items-start gap-2 sm:grid-cols-2">
              <proffeo-ui-choice-group
                (valueChange)="onBreakPreset($event)"
                [value]="selectedBreakPreset()"
                [options]="breakOptions"
                [columns]="3"
                [translateLabels]="false"
                [ariaLabel]="'time-reports.series.deduct-break' | translate"
              />
              <proffeo-ui-input
                (valueChange)="onBreakInput($event)"
                [value]="s.model().breakMinutes"
                type="number"
                label="time-reports.series.break-custom"
              />
            </div>
          }

          @if (s.suggestedBreakStartLabel()) {
            <p class="proffeo-ui-text-muted m-0 text-sm">
              {{ 'time-reports.series.break-start-suggestion' | translate: { time: s.suggestedBreakStartLabel() } }}
            </p>
          }
        </div>
      }

      @if (s.dailyRangeErrorKey()) {
        <mat-error class="text-sm">{{ s.dailyRangeErrorKey() | translate }}</mat-error>
      }

      @if (attachmentsNote()) {
        <p
          role="note"
          data-testid="report-series-attachments-note"
          class="proffeo-ui-text-muted m-0 text-sm"
        >
          {{ 'time-reports.series.attachments-first-day' | translate }}
        </p>
      }
    }
  </section>
}
